function getFocusableElements(container) {
  return Array.from(
      container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
  );
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/**
 * Global properties
 */
let activeClassName = 'is-active',
    openClassName = 'is-open',
    sliderControls = '.slider-controls',
    gridColumns = 12,
    gridGutter = 24,
    gridBreakpoints = {
      xs: 0,
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1200,
      xxl: 1400,
      xxxl: 1500,
      xxxxl: 1650
    };

/**
 * Global functions
 */

/**
 * Debounce
 * @param fn
 * @param wait
 * @returns {(function(...[*]): void)|*}
 */
function debounce(fn, wait = ON_CHANGE_DEBOUNCE_TIMER) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
      'focus',
      () => {
        if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

        if (mouseClick) return;

        currentFocusedElement = document.activeElement;
        currentFocusedElement.classList.add('focused');
      },
      true
  );
}

/**
 * throttle
 * @param fn
 * @param delay
 * @returns {function(...[*]): *}
 */
function throttle(fn, delay = ON_CHANGE_DEBOUNCE_TIMER) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

/**
 * set view width, fix
 */
function setVw() {
  let vw = document.documentElement.clientWidth / 100;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
}

setVw();
window.addEventListener('resize', setVw);

/**
 * ItemSlider Properties
 */
let itemSliderObjects = {};
let itemSliderElements = '.item-slider';
let itemSliderContainer = '.item-slider-inner';
let itemSliderGutter = gridGutter / 2;
let itemSliderColumnsDefault = 2;
let itemSliderColumnsSettings = {};
let itemSliderControlsContainer = '.slider-controls';

// -- set default Columns config
itemSliderColumnsSettings[gridBreakpoints['md']] = {
  items: 3,
  slideBy: 1
};
itemSliderColumnsSettings[gridBreakpoints['lg']] = {
  items: 4,
  slideBy: 1
};
itemSliderColumnsSettings[gridBreakpoints['xl']] = {
  items: 5,
  slideBy: 1
};

/**
 * Product detail accordion
 */
let accordionToggle = '.product-content-item-toggle';

function initializeDetailAccordion() {
  var accordionToggles = document.querySelectorAll(accordionToggle);

  if ( accordionToggles.length > 0 ) {
    accordionToggles.forEach((button) => {

      button.addEventListener('click', function(event) {
        event.preventDefault();

        var thisAccordion = this;
        var thisAccordionItem = thisAccordion.parentNode;

        thisAccordionItem.classList.toggle('is--open');
      });

    });
  }
}

initializeDetailAccordion();



/**
 * Video opener
 */
function videoContainer() {
    document.addEventListener('click', function(e) {
        // Open video modal
        const openBtn = e.target.closest('.open-video-modal');
        if (openBtn) {
            e.preventDefault();
            const container = openBtn.closest('.product-media-container')?.querySelector('.video-container');
            if (container) {
                container.classList.add('is-open');
                const video = container.querySelector('video');
                if (video) {
                    video.currentTime = 0; // Reset to start
                    video.play().catch(err => console.warn('Video autoplay prevented:', err));
                }
            }
        }

        // Close video modal
        const closeBtn = e.target.closest('.video-container-close');
        if (closeBtn) {
            e.preventDefault();
            const container = closeBtn.closest('.video-container');
            if (container) {
                const video = container.querySelector('video');
                if (video) {
                    video.pause();
                    video.currentTime = 0; // Reset to start
                }
                container.classList.remove('is-open');
            }
        }
    });
}

// Initialize
videoContainer();

/**
 * Customer Reviews
 */
let customerReviewsSliders = {};
let customerReviewsSliderEl = '.customer-reviews-slider';

function initializeCustomerReviews() {
    var getSliders = document.querySelectorAll(customerReviewsSliderEl);

    if ( getSliders.length > 0 ) {
      getSliders.forEach((slider) => {
        var thisId = slider.id;
        var thisContainer = '#' + thisId + ' .customer-reviews-slider-inner';
        var thisControls = '#' + thisId + ' .slider-controls';


        customerReviewsSliders[thisId] = tns({
          items: 1,
          slideBy: 1,
          loop: true,
          autoplay: true,
          autoplayTimeout: 8000,
          gutter: gridGutter,
          container: thisContainer,
          nav: false,
          controls: true,
          controlsContainer: thisControls,
          responsive: {
            768: {
              items: 2,
              slideBy: 1,
            },
            992: {
              items: 3,
              slideBy: 1
            }
          }
        })
      })
    }
}

initializeCustomerReviews();

/**
 * Item slider
 */
function initializeItemSlider() {
  var sliderElements = document.querySelectorAll(itemSliderElements),
      sliderContainer = null,
      sliderControlsContainer = null;

  //
  if ( sliderElements.length > 0 ) {
    sliderElements.forEach((sliderElement) => {
      var thisSliderDataset = sliderElement.dataset;
      var thisSliderID = sliderElement.id;
      var thisSliderContainer = '#' + thisSliderID + ' ' + itemSliderContainer;
      var thisSliderControlsContainer = '#' + thisSliderID + ' ' + itemSliderControlsContainer;
      var thisSliderGutter = itemSliderGutter;
      var thisSliderColumnsDefault = itemSliderColumnsDefault;
      var thisSliderColumnsSettings = itemSliderColumnsSettings;
      var thisSliderLoop = false;
      var thisSliderNav = false;
      var thisSliderControls = true;
      var thisSliderNavPosition = "bottom";

      // -- only run, if not initalized
      if ( !document.querySelectorAll(thisSliderContainer)[0].classList.contains('tns-slider') ) {

        /**
         * Override config variables by data attributes
         */

        // -- default cols
        if ( typeof thisSliderDataset.columnsDefault !== 'undefined' ) {
          thisSliderColumnsDefault = thisSliderDataset.columnsDefault;
        }

        // -- col settings
        if ( typeof thisSliderDataset.columnsSettings !== 'undefined' ) {
          // -- reset
          thisSliderColumnsSettings = {};

          if ( thisSliderDataset.columnsSettings !== '' ) {
            var parseConfig = JSON.parse(thisSliderDataset.columnsSettings);

            Object.keys(parseConfig).forEach(function(key) {
              if ( typeof gridBreakpoints[key] !== 'undefined' ) {
                thisSliderColumnsSettings[gridBreakpoints[key]] = {
                  items: parseConfig[key],
                  slideBy: 1,
                  fixedWidth: false,
                  viewportMax: false,
                };
              } else {
                if ( !isNaN(key) ) {
                  thisSliderColumnsSettings[key] = {
                    items: parseConfig[key],
                    slideBy: 1,
                    fixedWidth: false,
                    viewportMax: false,
                  };
                }
              }
            })
          }
        }

        // -- controls
        if ( typeof thisSliderDataset.sliderControls !== 'undefined' ) {
          thisSliderLoop = thisSliderDataset.sliderControls;
        }

        // -- loop
        if ( typeof thisSliderDataset.sliderLoop !== 'undefined' ) {
          thisSliderLoop = thisSliderDataset.sliderLoop;
        }

        // -- nav
        if ( typeof thisSliderDataset.sliderNav !== 'undefined' ) {
          thisSliderNav = thisSliderDataset.sliderNav;
        }

        // -- nav position
        if ( typeof thisSliderDataset.sliderNavPosition !== 'undefined' ) {
          thisSliderNavPosition = thisSliderDataset.sliderNavPosition;
        }

        itemSliderObjects[thisSliderID] = tns({
          container: thisSliderContainer,
          gutter: thisSliderGutter,
          nav: thisSliderNav,
          navPosition: thisSliderNavPosition,
          controls: thisSliderControls,
          loop: thisSliderLoop,
          items: thisSliderColumnsDefault,
          slideBy: 1,
          fixedWidth: 260,
          responsive: thisSliderColumnsSettings,
          controlsContainer: thisSliderControlsContainer
        });

      }

    });
  }
}

// -- run itemSlider
initializeItemSlider();

/**
 * Offcanvas Menu
 */
let offcanvasMenuToggle = '#navigation-toggle';
let offcanvasMenuTarget = '.page-navigation';
let offcanvasMenuBackdrop = '.page-navigation-backdrop';
let offcanvasMenuClose = '.page-navigation-close';
let offcanvasMenuSubLink = '.open-sub-menu';
let offcanvasMenuBackLink = '.navigation-dropdown-back';

function initializeOffcanvsNavigation() {

  var getOffcanvasMenuTarget = document.querySelectorAll(offcanvasMenuTarget);
  var getOffcanvasMenuToggle = document.querySelectorAll(offcanvasMenuToggle)[0];
  var getOffcanvasMenuBackdrop = document.querySelectorAll(offcanvasMenuBackdrop)[0];
  var getOffcanvasMenuClose = document.querySelectorAll(offcanvasMenuClose)[0];
  var getOffcanvasSubmenuLinks = document.querySelectorAll(offcanvasMenuSubLink);
  var getOffcanvasSubmenuBackLinks = document.querySelectorAll(offcanvasMenuBackLink);

  if ( getOffcanvasMenuTarget.length > 0 ) {
    getOffcanvasMenuTarget = getOffcanvasMenuTarget[0];

    getOffcanvasMenuToggle.addEventListener('click', function(event) {
      event.preventDefault();

      var _this = this;

      _this.classList.toggle(openClassName);
      getOffcanvasMenuTarget.classList.toggle(openClassName);
      getOffcanvasMenuBackdrop.classList.toggle(openClassName);

      event.stopPropagation();
    })

    getOffcanvasSubmenuBackLinks.forEach((toggle) => {
      toggle.addEventListener('click', function(event) {

        var thisBack = this;
        var thisBackParent = thisBack.closest('.sub-wrapper');

        thisBackParent.classList.remove(openClassName);

      })
    })

    getOffcanvasSubmenuLinks.forEach((toggle) => {
      toggle.addEventListener('click', function(event) {
        event.preventDefault();

        var thisToggle = this;
        var thisWrapper = thisToggle.parentNode;

        thisWrapper.classList.add(openClassName);

        event.stopPropagation();
      });
    });

    getOffcanvasMenuClose.addEventListener('click', function(event) {
      event.preventDefault();

      getOffcanvasMenuTarget.classList.remove(openClassName);
      getOffcanvasMenuToggle.classList.remove(openClassName);
      getOffcanvasMenuBackdrop.classList.toggle(openClassName);

      event.stopPropagation();
    })

    getOffcanvasMenuBackdrop.addEventListener('click', function(event) {
      event.preventDefault();

      var _this = this;

      _this.classList.remove(openClassName);
      getOffcanvasMenuTarget.classList.remove(openClassName);
      getOffcanvasMenuToggle.classList.remove(openClassName);

      event.stopPropagation();
    })
  }

}

initializeOffcanvsNavigation();

/**
 * Announcement bar slider
 */
let announcementBarSliderObj = null;
let announcementBarSlider = '.announcement-bar-slider';
let announcementBarSliderContainer = announcementBarSlider + ' .announcement-bar-slider-inner';
let announcementBarSliderControls = announcementBarSlider + ' .slider-controls';

function initializeAnnouncementBarSlider() {
  var getAnnouncementBarSliderEl = document.querySelectorAll(announcementBarSlider);

  if ( getAnnouncementBarSliderEl.length > 0 ) {
    announcementBarSliderObj = tns({
      container: announcementBarSliderContainer,
      items: 1,
      slideBy: 1,
      autoplayButtonOutput: false,
      autoplay: true,
      autoplayTimeout: 7000,
      gutter: 0,
      // loop: false,
      nav: false,
      controls: true,
      controlsContainer: announcementBarSliderControls
    });
  }
}

initializeAnnouncementBarSlider();

/**
 * Product detail gallery
 */
let productDetailMediaGalleryObject = null;
let productDetailMediaGallery = '.product-media-gallery';
let productDetailMediaGalleryContainer = productDetailMediaGallery + ' .product-media-gallery-inner';
let productDetailMediaGalleryControls = productDetailMediaGallery + ' .slider-controls';

function initializeProductDetailMediaGallery() {

  var getProductDetailMediaGallery = document.querySelector(productDetailMediaGallery);

  if ( getProductDetailMediaGallery !== null ) {
    productDetailMediaGalleryObject = tns({
      container: productDetailMediaGalleryContainer,
      items: 1,
      slideBy: 1,
      controls: true,
      controlsContainer: productDetailMediaGalleryControls,
      nav: false,
      autoplay: false,
      loop: false
    });

      // Handle video when slide changes
      if (productDetailMediaGalleryObject && productDetailMediaGalleryObject.events) {
        productDetailMediaGalleryObject.events.on('indexChanged', function(info) {
            // Find all slides
            var allSlides = document.querySelectorAll('.product-media-gallery .tns-item');

            allSlides.forEach(function(slide) {
                // Skip the current active slide
                if (!slide.classList.contains('tns-slide-active')) {
                    var videoContainer = slide.querySelector('.video-container.is-open');

                    if (videoContainer) {
                        var video = videoContainer.querySelector('video');
                        if (video) {
                            video.pause();
                            video.currentTime = 0; // Reset to start
                        }
                        videoContainer.classList.remove('is-open');
                    }
                }
            });
        });
      }
  }

}

initializeProductDetailMediaGallery();

/**
 * Input config form
 */

let productConfigForm = '.product__form';
let productBuyButton = '.product-form__submit';

function enableBuyButtonByForm(fields) {
  var validateBuy = false;
  var getProductBuyButton = document.querySelector(productBuyButton);
  var indexField = 0;

  fields.forEach((field) => {
    if ( field.required ) {
      if ( indexField !== 0 && validateBuy === false ) {
        validateBuy = false;
      } else {
        if ( field.value !== '' ) {
          validateBuy = true;
        } else {
          validateBuy = false;
        }
      }

      indexField++;
    }
  });

  if ( validateBuy ) {
    getProductBuyButton.disabled = false;
  } else {
    getProductBuyButton.disabled = true;
  }
}

function initializeProductConfigForm() {
  var getProductConfigFields = document.querySelectorAll(productConfigForm + ' .form-input');

  if ( getProductConfigFields.length > 0 ) {
    getProductConfigFields.forEach((field) => {
        var fieldRequired = field.required;

        if ( fieldRequired ) {
          field.addEventListener('change', function() {
            var fieldsToValidate = document.querySelectorAll(productConfigForm + ' .form-input, ' + productConfigForm + ' .file-upload-input');

            enableBuyButtonByForm(fieldsToValidate);
          });
        }
      });
  }
}

initializeProductConfigForm();

/**
 * Quantity input
 */

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
        button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

/**
 * Model select
 */
let modelSelectPreview = document.querySelectorAll('.image-case-overlay');
let modelSelectInput = document.querySelector('.select__model');

function modelSelect() {
  if ( modelSelectInput && modelSelectInput.length > 0 && modelSelectPreview.length > 0 ) {
    modelSelectInput.addEventListener('change', function(event) {

      var thisModelFile = modelSelectInput.options[this.selectedIndex].dataset.modelCase;

      modelSelectPreview.forEach((preview) => {
        preview.style.cssText = (
            'background-image: url("'+ thisModelFile +'.png");'
        );
      });

      // check for warning
      var thisWrapper = this.closest('.product-form__input');
      var thisWarning = thisWrapper.querySelector('.product-form__warning');

      console.log(thisWrapper);
      console.log(thisWarning);

      if ( typeof thisWarning !== 'undefined' ) {
        var getWarningData = thisWarning.dataset.models;
        var getWarningDataArr = getWarningData.split(',');

        if ( getWarningDataArr.includes(this.value.trim()) ) {
          thisWarning.classList.add('show');
        } else {
          thisWarning.classList.remove('show');
        }
      }

    });
  }
}

modelSelect();

/**
 * Hotspot
 */
let hotspotButton = '.hotspot-item-button';

function hotSpotButtonInit() {
  // Click Handler für Hotspot Buttons
  document.querySelectorAll(hotspotButton).forEach(button => {
    button.addEventListener('click', function(e) {
      e.stopPropagation(); // Verhindert Bubble-up

      // Entferne alle aktiven Klassen von anderen Hotspots
      document.querySelectorAll(hotspotButton).forEach(otherButton => {
        if (otherButton !== this) {
          otherButton.classList.remove('is-active');
          otherButton.parentNode.classList.remove('is-active');
        }
      });

      // Toggle aktive Klasse für geklickten Button und dessen Parent
      this.classList.toggle('is-active');
      this.parentNode.classList.toggle('is-active');
    });
  });

  // Click Handler für Document (außerhalb der Hotspots)
  document.addEventListener('click', function(e) {
    if (!e.target.closest(hotspotButton) &&
        !e.target.closest('.hotspot-item-content')) {
      // Entferne alle aktiven Klassen
      document.querySelectorAll(hotspotButton).forEach(button => {
        button.classList.remove('is-active');
        button.parentNode.classList.remove('is-active');
      });
    }
  });
}

hotSpotButtonInit();


/**
 * Slideshows
 */
let slideshowObjects = {};
let slideshowEls = document.querySelectorAll('.slideshow-block');
let slideshowContainer = '.slideshow-block-container';


function slideshowInit() {
  console.log(slideshowEls);
  if ( slideshowEls.length > 0 ) {
    slideshowEls.forEach((slideshowEl) => {

      var slideshowId = slideshowEl.id;
      var slideshowContainerClass = '#' + slideshowId + ' ' + slideshowContainer;
      var slideshowControls = '#' + slideshowId + ' .slider-controls';

      slideshowObjects[slideshowId] = tns({
        container: slideshowContainerClass,
        gutter: 0,
        nav: false,
        controls: true,
        loop: true,
        autoplay: true,
        autoplayTimeout: 10000,
        items: 1,
        slideBy: 1,
        controlsContainer: slideshowControls
      });
    });
  }
}

slideshowInit();

/**
 * Cropping element
 */

let imageEditor = null;
let imageEditorElement = document.querySelector('.image-editor');
let imageEditorStorage = document.querySelector('#cropping');
let imageEditorSet = document.querySelector('#set-crop-data');
let imageEditorPreviews = document.querySelectorAll('.image-cropper-preview');

function each(arr, callback) {
  var length  = arr.length;
  var i;

  for ( i = 0; i < length; i++ ) {
    callback.call(arr, arr[i], i, arr);
  }

  return arr;
}

class ImageCropper extends HTMLElement {
  constructor() {
    super();
    this.image = this.querySelector('#custom-image');
    this.close = this.querySelectorAll('.image-cropper-close');

    this.imageObserver = new MutationObserver((changes) => {
        changes.forEach(change => {
          if ( change.attributeName.includes('src') ) {
            this.onImageChange(this.image.src);
          }
        });
    });

    this.imageObserver.observe(this.image, {attributes: true});

    // close
    this.close.forEach((button) => {
      button.addEventListener('click', function(event) {
        imageEditorElement.classList.remove('is--open');
      });
    });

    // set crop
    imageEditorSet.addEventListener('click', function(event) {
      event.preventDefault();

      if ( imageEditor !== null ) {
        var getData = imageEditorStorage.value;

        imageEditor.setData(JSON.parse(getData));
      }
    });
  }

  /**
   * On image change
   * @param src
   */
  onImageChange(src) {
    if ( src === 'http://127.0.0.1:9292/products/personalisierte-handyhulle' ) {
      imageEditor.destroy();
    } else {
      var minAspectRatio = (357 / 731);
      var maxAspectRatio = (357 / 731);
      var previewReady = false;

      if ( imageEditor !== null ) {
        imageEditor.destroy();
      }

      imageEditor = new Cropper(this.image, {
        zoomable: false,
        autoCrop: true,
        aspectRatio: maxAspectRatio,
        ready: function () {
          var cropper = this.cropper;
          var containerData = cropper.getContainerData();
          var cropData = cropper.getData();
          var cropBoxData = cropper.getCropBoxData();
          var aspectRatio = cropBoxData.width / cropBoxData.height;
          var clone = this.cloneNode();
          var newCropBoxWidth;

          // - set clone data
          clone.className = '';
          clone.style.cssText = (
              'display: block;' +
              'width: 100%;' +
              'min-height: 0;' +
              'min-width: 0;' +
              'max-width: none;' +
              'min-width: none;'
          );

          // -- set crop data in field
          imageEditorStorage.value = JSON.stringify(cropData);

          // -- aspect ratio
          if (aspectRatio < minAspectRatio || aspectRatio > maxAspectRatio) {
            newCropBoxWidth = cropBoxData.height * ((minAspectRatio + maxAspectRatio) / 2);

            cropper.setCropBoxData({
              left: (containerData.width - newCropBoxWidth) / 2,
              width: newCropBoxWidth
            });
          }

          // clear previews
          each(imageEditorPreviews, function (elem)  {
            elem.innerHTML = '';
          });

          // previews
          each(imageEditorPreviews, function (elem)  {
            elem.classList.add('is--active');
            elem.appendChild(clone.cloneNode());
          });

          previewReady = true;

          imageEditorElement.classList.add('is--open');

          // crop
          cropper.setCropBoxData({
            height: cropper.getContainerData().height,
            left: 0,
            top: 0,
            width: cropper.getContainerData().width
          })
        },

        cropend: function() {
          var cropper = this.cropper;
          var cropData = cropper.getData();

          imageEditorStorage.value = JSON.stringify(cropData);
        },

        crop: function(event)  {
          if ( !previewReady ) {
            return;
          }

          var data = event.detail;
          var cropper = this.cropper;
          var imageData = cropper.getImageData();
          var previewAspectRatio = data.width / data.height;

          each(imageEditorPreviews, function(elem) {

            var previewImage = elem.getElementsByTagName('img').item(0);
            var previewWidth = elem.offsetWidth;
            var previewHeight = previewWidth / previewAspectRatio;
            var imageScaledRatio = data.width / previewWidth;

            elem.style.height = previewHeight + 'px';

            previewImage.style.width = imageData.naturalWidth / imageScaledRatio + 'px';
            previewImage.style.height = imageData.naturalHeight / imageScaledRatio + 'px';
            previewImage.style.marginLeft = -data.x / imageScaledRatio + 'px';
            previewImage.style.marginTop = -data.y / imageScaledRatio + 'px';

          });
        },

        zoom: function() {
          var cropper = this.cropper;
          var cropData = cropper.getData();

          imageEditorStorage.value = JSON.stringify(cropData);
        },

        zoomOnWheel: function() {
          var cropper = this.cropper;
          var cropData = cropper.getData();

          imageEditorStorage.value = JSON.stringify(cropData);
        },

        zoomOnTouch: function() {
          var cropper = this.cropper;
          var cropData = cropper.getData();

          imageEditorStorage.value = JSON.stringify(cropData);
        },

        cropmove: function () {
          var cropper = this.cropper;
          var cropBoxData = cropper.getCropBoxData();
          var cropData = cropper.getData();
          var aspectRatio = cropBoxData.width / cropBoxData.height;

          imageEditorStorage.value = JSON.stringify(cropData);

          if (aspectRatio < minAspectRatio) {
            cropper.setCropBoxData({
              width: cropBoxData.height * minAspectRatio
            });
          } else if (aspectRatio > maxAspectRatio) {
            cropper.setCropBoxData({
              width: cropBoxData.height * maxAspectRatio
            });
          }
        },
      })
    }
  }
}


customElements.define('image-cropper', ImageCropper);

/**
 * FIle upload element
 */

class FileUploadContainer extends HTMLElement {
  /**
   * Constructor
   */
  constructor() {
    super();

    this.input = this.querySelector("input.file-upload-input");
    this.button = this.querySelector('button.file-upload-button');
    // this.errorMessage = this.querySelector('.file-upload-error-message');
    this.buttonRemove = this.querySelector('.file-upload-preview-remove');
    this.fileName = this.querySelector(".file-upload-preview .file-upload-preview-name");
    this.fileImage = this.querySelector(".file-upload-preview .file-upload-preview-image-tag");
    this.fileImageWrapper = this.querySelector(".file-upload-preview");
    this.fileCropperImage = document.querySelector('#custom-image');

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.button.addEventListener('click', this.onButtonClick.bind(this));
    this.buttonRemove.addEventListener('click', this.removeImage.bind(this));
  }

  /**
   * Remove image
   * @param event
   */
  removeImage(event) {
    event.preventDefault();

    this.input.value = '';

    // clear previews
    each(imageEditorPreviews, function (elem)  {
      elem.classList.remove('is--active');
      elem.innerHTML = '';
    });

    var inputEvent = new Event('change');

    this.input.dispatchEvent(inputEvent);
  }

  /**
   * Preview Image
   * @param input
   */
  previewImage(files, image, cropperImage) {
    if ( files && files[0] ) {
      var inputReader = new FileReader();

      inputReader.onload = function(event) {
        image.setAttribute('src', event.target.result);
        cropperImage.setAttribute('src', event.target.result);
      }

      inputReader.readAsDataURL(files[0]);
    }
  }

  /**
   * Input change
   * @param event
   */
  onInputChange(event) {
    const files = event.target.files;

    let fileName;


    if ( files.length === 0 ) {
      fileName = 'Kein Foto hochgeladen';

      // reset filename
      this.fileImage.setAttribute('src', '');
      this.fileCropperImage.setAttribute('src', '');
      this.fileImageWrapper.classList.remove('__show');

      // show button
      this.button.style.display = 'flex';

      // hide error
      // if ( this.errorMessage.length > 0 ) {
      //   this.errorMessage.style.display = 'block';
      // }
    }
    else {
      fileName = files[0].name;

      // hide button
      this.button.style.display = 'none';

      // show error
      // if ( this.errorMessage.length > 0 ) {
      //   this.errorMessage.style.display = 'none';
      // }

      // preview image
      this.fileImageWrapper.classList.add('__show');
      this.previewImage(files, this.fileImage, this.fileCropperImage);
    }

    var fieldsToValidate = document.querySelectorAll(productConfigForm + ' .form-input, ' + productConfigForm + ' .file-upload-input');

    enableBuyButtonByForm(fieldsToValidate);

    this.fileName.textContent = fileName;
  }

  /**
   * Button click
   * @param event
   */
  onButtonClick(event) {
    event.preventDefault();

    this.input.click();
  }
}

customElements.define('file-upload-container', FileUploadContainer);

/**
 * Modal Dialog
 */
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    // this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      // this.toggleAddButton(true, '', true);
      // this.setUnavailable();
      console.log('BLABLA');
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
            if (element.tagName === 'SELECT') {
                return element.value;
            }
            if (element.tagName === 'FIELDSET') {
                return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
            }
        });
    }

  updateMasterId() {
    // Prüfe ob alle Optionen einen Wert haben (nicht leer)
    const allOptionsSelected = this.options.every(option => option && option !== '');

    if (!allOptionsSelected) {
      this.currentVariant = null;
      return;
    }

    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
        mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }


  getCurrentVariantData() {
    const variantData = this.getVariantData();
    return variantData;
  }


  updateVariantStatuses() {
    const variant = this.getCurrentVariantData();

    if (!variant) {
      // this.toggleAddButton(true, window.variantStrings.unavailable);
      return;
    }

    // Prüfen Sie explizit, ob die Variante verfügbar ist
    if (variant.available === false) {
      // this.toggleAddButton(true, window.variantStrings.soldOut);
    } else {
      // this.toggleAddButton(false, '', true);
    }
  }


  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
            ? value
            : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
        `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
            this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
        }`
    )
        .then((response) => response.text())
        .then((responseText) => {
          // prevent unnecessary ui changes from abandoned selections
          if (this.currentVariant.id !== requestedVariantId) return;

          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const destination = document.getElementById(`price-${this.dataset.section}`);
          const source = html.getElementById(
              `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
          );
          const skuSource = html.getElementById(
              `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
          );
          const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
          const inventorySource = html.getElementById(
              `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
          );
          const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

          const volumePricingSource = html.getElementById(
              `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
          );

          const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
          const pricePerItemSource = html.getElementById(
              `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
          );

          const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
          const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
          const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

          if (volumeNote) volumeNote.classList.remove('hidden');
          if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
          if (qtyRules) qtyRules.classList.remove('hidden');

          if (source && destination) destination.innerHTML = source.innerHTML;
          if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
          if (skuSource && skuDestination) {
            skuDestination.innerHTML = skuSource.innerHTML;
            skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
          }

          if (volumePricingSource && volumePricingDestination) {
            volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
          }

          if (pricePerItemSource && pricePerItemDestination) {
            pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
            pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
          }

          const price = document.getElementById(`price-${this.dataset.section}`);

          if (price) price.classList.remove('hidden');

          if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

          const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
          // this.toggleAddButton(
          //     addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          //     window.variantStrings.soldOut
          // );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId,
              html,
              variant: this.currentVariant,
            },
          });
        });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;

    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    // Logging für Debug-Zwecke
    console.log('Toggle Button:', {
      disable,
      text,
      modifyClass,
      currentVariant: this.getCurrentVariantData()
    });

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }


  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);
